import script from "./form2View.vue?vue&type=script&setup=true&lang=js"
export * from "./form2View.vue?vue&type=script&setup=true&lang=js"

import "./form2View.vue?vue&type=style&index=0&id=4cb4a418&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cb4a418"]])

export default __exports__